import { PaymentTaskExpenseAccountItem } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 2370. 支払タスク費用科目金額編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_expense_account_items/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
  amount: number;
};

const updatePaymentTaskExpenseAccountItem = (props: Props): Promise<PaymentTaskExpenseAccountItem> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_expense_account_items/${props.id}`,
    props
  );
};

export const useUpdatePaymentTaskExpenseAccountItem = () => {
  return useMutation({
    mutationFn: updatePaymentTaskExpenseAccountItem,
  });
};
